import React from 'react';
import { useDispatch } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import restApi, { RestApiController } from '../restApi';
import {
  reportUpdate,
  reportNodata,
  reopenReportDialog,
} from '../actions/index';

export default function(data) {
  const { addToast } = useToasts();
  const dispatch = useDispatch();

  return React.useMemo(() => {
    const controller = new RestApiController();

    const loadAsync = async () =>
      await new Promise((success, reject) => {
        const { signal } = controller;
        if (signal) {
          signal(reject, this);
        }

        restApi
          .getCustomReportAsync(
            data.objectId,
            data.customType,
            data.start,
            data.end,
          )
          .then(json => {
            if (json.ok) {
              dispatch(reportUpdate(`custom-report`, json.data, data));
            } else if (json.code === 404) {
              dispatch(reportNodata(`custom-report: ${data.customType}`, data));
            }
            success(json);
          })
          .catch(ex => {
            if (ex.reason !== 'canceled') {
              addToast('Възникна грешка при опит да се направи справка', {
                appearance: 'error',
                onDismiss: () => {
                  dispatch(reopenReportDialog(data.type));
                },
              });
              console.error(ex);
            }
            reject(ex);
          });
      });
    return { loadAsync: loadAsync, controller: controller };
  }, [data, dispatch, addToast]);
}
